import apiHelper from "services/apiHelper";

export const deviceStatusSettings = (imei) => {
  return apiHelper(`api/device_status/deviceinfo/${imei}`, "get", null, {});
};

export const updateImei = (newImei, oldImei, userEmail) => {
  return apiHelper(
    `api/imei/updateimei/${newImei}/${oldImei}`,
    "get",
    null,
    {}
  );
};

export const getQuickAccessBarApi = async (
  imei,
  family,
  successCallback,
  setLoading
) => {
  return await apiHelper(
    `api/quickaccessbar/${imei}/${family}`,
    "post",
    null,
    {}
  )
    .then((res) => {
      successCallback(res.data.data);
      if (setLoading) {
        setLoading(false);
      }
    })
    .catch((err) => console.error(err));
};

export const getQuickAccessBarUnreadCountApi = async (
  imei,
  successCallback,
  setLoading
) => {
  return await apiHelper(`api/unreadcounts/${imei}`, "post", null, {})
    .then((res) => {
      successCallback(res.data.data);
      if (setLoading) {
        setLoading(false);
      }
    })
    .catch((err) => {
      if (err?.response?.data?.status === 402) {
        successCallback({})
      }
      console.error(err)
    });
};

export const readCountApi = async (imei, appName) => {
  return await apiHelper(
    `api/data/readdata/${imei}/${appName}`,
    "get",
    null,
    {}
  )
    .then((res) => { })
    .catch((err) => console.error(err));
};
